module.exports = __webpack_public_path__ + "img/1.90b295a5.jpg";